import { render, staticRenderFns } from "./onlyDesign.vue?vue&type=template&id=265ee298&"
import script from "./onlyDesign.vue?vue&type=script&lang=ts&"
export * from "./onlyDesign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports